module.exports = __webpack_public_path__ + "assets/img/searchInFo.41fcd66d.png";